import React from 'react'

import { useServiceProvider } from '../hooks/useServiceProvider'

export function ServiceProvider({ id }: { id: string }) {
  const serviceProvider = useServiceProvider(id)
  return <>{serviceProvider?.name ?? id}</>
}
